import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import ProtectedRoute from "@/components/ProtectedRoute";
import CreditsNotice from "@/components/CreditsNotice";

import Landing from "@/pages/Landing";
import PublicSearch from "@/pages/PublicSearch";
import PublicProduct from "@/pages/PublicProduct";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminProducts from "@/pages/AdminProducts";
import AdminProductUpload from "@/pages/AdminProductUpload";
import AdminProductBulkUpload from "@/pages/AdminProductBulkUpload";
import AdminProductEdit from "@/pages/AdminProductEdit";
import AdminSettings from "@/pages/AdminSettings";
import AdminUsers from "@/pages/AdminUsers";
import AskHeda from "@/pages/AskHeda";
import AdminCustomers from "@/pages/AdminCustomers";
import AdminRebrand from "@/pages/AdminRebrand";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter basename={process.env.PUBLIC_URL || undefined}>
        <CreditsNotice />
        <Routes>
          {/* Public */}
          <Route path="/" element={<Landing />} />
          <Route path="/search" element={<PublicSearch />} />
          <Route path="/product/:code" element={<PublicProduct />} />

          {/* Admin */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/products"
            element={
              <ProtectedRoute>
                <AdminProducts />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/products/new"
            element={
              <ProtectedRoute>
                <AdminProductUpload />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/ask"
            element={
              <ProtectedRoute>
                <AskHeda />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/customers"
            element={
              <ProtectedRoute>
                <AdminCustomers />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/rebrand"
            element={
              <ProtectedRoute>
                <AdminRebrand />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/products/bulk"
            element={
              <ProtectedRoute>
                <AdminProductBulkUpload />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/products/:id/edit"
            element={
              <ProtectedRoute>
                <AdminProductEdit />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/settings"
            element={
              <ProtectedRoute>
                <AdminSettings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/users"
            element={
              <ProtectedRoute>
                <AdminUsers />
              </ProtectedRoute>
            }
          />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
